// Client-side helper that turns an API response into a browser download.
// Works for GET (just URL) and POST (sends body). Keeps consumers from
// reimplementing the blob / URL.createObjectURL dance every time.

export async function triggerDownload(
    url: string,
    filename: string,
    init?: RequestInit,
): Promise<void> {
    const res = await fetch(url, init ?? { method: 'GET' });
    if (!res.ok) {
        const text = await res.text().catch(() => '');
        throw new Error(`Download failed (${res.status}): ${text.slice(0, 200) || res.statusText}`);
    }

    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    // Release the blob shortly after click triggers the download.
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}
